export default {
    /**
     * *  0  姓名，组别，比赛名
        * 1  姓名，组别，倒计时
        * 2  倒计时
        * 3  姓名，比赛名
        * 4  姓名，比赛名，倒计时
        * 5  比赛名  （编程一小时）
        */
    COMPETE_TYPE_0:0,
    COMPETE_TYPE_1:1,
    COMPETE_TYPE_2:2,
    COMPETE_TYPE_3:3,
    COMPETE_TYPE_4:4,
    COMPETE_TYPE_TOUR: 5,//// 体验关卡

}


// WEBPACK FOOTER //
// ./src/const/Const.js